import React,{useState,useContext,createContext} from 'react';
import {Title,Body,Header,Item,Container,Inner} from './styles/accordion'



const ToggleContext= createContext();

export default function Accordion({children,...restProps}){
    return (
        <Container>
            <Inner>{children}</Inner>
        </Container> 
    );
}


Accordion.Title = function AccordionTitle({children,...restProps}){
    return <Title {...restProps}>{children}</Title>
}

Accordion.Body = function AccordionBody({children,...restProps}){
    const { toggleShow } = useContext(ToggleContext);
    return toggleShow? <Body {...restProps}>{children}</Body>:null;
}

Accordion.Header = function AccordionHeader({children,...restProps}){
    const {toggleShow,setToggleShow}= useContext(ToggleContext);
    return <Header onClick={()=>{setToggleShow((toggleShow)=>!toggleShow)}} {...restProps}>{children} {toggleShow?<img src={`${process.env.PUBLIC_URL}/images/icons/close-slim.png`} alt="close" />:<img src={`${process.env.PUBLIC_URL}/images/icons/add.png`} alt="add" />} </Header>
}

Accordion.Item = function AccordionItem({children,...restProps}){
    const [toggleShow,setToggleShow]= useState(false);
    return (
        <ToggleContext.Provider value={{toggleShow,setToggleShow}}>
        <Item {...restProps}>{children}</Item>
        </ToggleContext.Provider>
    )
}